export default __webpack_public_path__ + "static/media/Reimbursement_2.439ec17d.png";